import React, { useState } from 'react'
import {
    CRow,
    CCol,
    CCard,
    CCardHeader,
    CCardBody,
    CBadge,
    CLink
} from '@coreui/react'
import { useSelector, useDispatch } from 'react-redux'
import classNames from 'classnames'
import history from '../../../../history'
import { dispatch } from 'd3'
import { 
  SET_FEDERAL_POLL_MAP, 
  SET_POLL_MAP, 
  SET_SEARCH_RESULTS, 
  SET_MAP_SELECTED, 
  SET_MAP_COUNT, 
  SET_POLL_MAP_YEAR, 
  SET_POLL_MAP_LOCAL_DIVISION,
  SET_PROVINCIAL_POLL_MAP
} from '../../../../redux/actions'
import { provinceShortToLong } from '../../../../helpers/Utils'

const SearchResultsProvincialPollMaps = (props) => {

  //const [showWindow, setShowWindow] = useState(true);
  const darkMode = useSelector(state => state.starter.darkMode)
  const dispatch = useDispatch()
  const showSearchResults = useSelector(state => state.starter.searchResults)
  const mapCount = useSelector(state => state.starter.mapCount)

  const classes = classNames(
    'card ',
    darkMode && 'map-search-results-dark'
  )

  const goToProvincial = (result) => {
    //dispatch({type: SET_POLL_MAP, pollMap: result})
    dispatch({type: SET_MAP_SELECTED, mapSelected: result})
    dispatch({type: SET_SEARCH_RESULTS, searchResults: false})
    dispatch({type: SET_POLL_MAP_YEAR, pollMapYear: result.year})
    dispatch({type: SET_PROVINCIAL_POLL_MAP, yearDivision: result.year+result.local_division})
    dispatch({type: SET_POLL_MAP_LOCAL_DIVISION, pollMapLocalDivision: result.local_division})
    dispatch({type: SET_MAP_COUNT, mapCount: mapCount+1})
    // history.push('/political/canada/provincial/election/'+provinceShortToLong(result.minor_jurisdiction).toLowerCase()+'/'+result.year+'/'+result.local_division);
    document.getElementById('pollmapsearch').value = '';
    //dispatch({type: SET_POLL_MAP, pollMap: result})
  }

    return (
      <div style={{position:'relative'}}>
        { showSearchResults && props ? props.theData ? props.theData.findProvincialPollMaps ? props.theData.findProvincialPollMaps.maps ? (props.theData.findProvincialPollMaps.maps.length > 0 || props.theData.findProvincialPollMaps.candidates.length > 0 ) ?  
        <div className={classes} style={{position:'absolute', minWidth:'75%', zIndex:'10000', height:'auto', top:'-10px', left:'42px', paddingTop:'10px', paddingBottom:'10px'}}>
        <div className="container">
        <div className="row" style={{marginLeft:0, marginRight:0}}>
        { props.theData.findProvincialPollMaps.maps.length > 0 ? 
          <div className="col-md">
            <h2>Ridings</h2>
        { props.theData.findProvincialPollMaps.maps.map((result, i) => (
          
        <CLink key={i} to={'/political/canada/provincial/election/'+provinceShortToLong(result.minor_jurisdiction).toLowerCase()+'/'+result.year+'/'+result.local_division}><div key={i} style={{cursor:'pointer'}} onClick={() => goToProvincial(result)}>
          { result.district } <CBadge className="mr-1 float-left" color={ 
            result.hasOwnProperty('winner') ? 
            result.winner === 'Conservative' ? "primary" : 
            result.winner === 'United Conservative' ? "primary" : 
            result.winner === 'Wildrose' ? "darkpurple" : 
            result.winner === "Liberal" ? "danger" : 
            result.winner === "NDP" ? "warning" : 
            result.winner === "Bloc Québécois" ? "info" : 
            result.winner === "Canadian Alliance" ? "darkgreen" : 
            result.winner === "Green Party" ? "success" : 
            result.winner === "Progressive Conservative" ? "lightblue" : 
            "secondary" : "secondary" }>{result.year}</CBadge>
          { i !== props.theData.findProvincialPollMaps.maps.length - 1 ? <div className="dropdown-divider"></div> : <></> }
        </div></CLink>
        ))} 
        </div> : <></> }
        { props.theData.findProvincialPollMaps.candidates.length > 0 ? 
          <div className="col-md">
            <div className="d-sm d-md-none d-lg-none d-xl-none d-xxl-none">&nbsp;</div>
          <h2>Candidates</h2>  
        { props.theData.findProvincialPollMaps.candidates.map((result, i) => (
        <CLink key={i} to={'/political/canada/provincial/election/'+provinceShortToLong(result.minor_jurisdiction).toLowerCase()+'/'+result.year+'/'+result.local_division}><div key={i} style={{cursor:'pointer'}} onClick={() => goToProvincial(result)}>
        { result.candidate_name } <CBadge className="mr-1 float-left" color={ 
          result.candidate_party_code === 'ON_L' ? "danger" : 
          result.candidate_party_code === 'ON_OLP' ? "danger" : 
          result.candidate_party_code === 'ON_LIB' ? "danger" : 
          result.candidate_party_code === 'AB_LIB' ? "danger" :                     
          result.candidate_party_code === 'ON_PCP' ? "primary" : 
          result.candidate_party_code === 'ON_PC' ? "primary" :
          result.candidate_party_code === 'AB_PC' ? "primary" :
          result.candidate_party_code === 'AB_UCP' ? "primary" :
          result.candidate_party_code === 'ON_ND' ? "warning" :
          result.candidate_party_code === 'ON_NDP' ? "warning" :
          result.candidate_party_code === 'AB_NDP' ? "warning" :
          result.candidate_party_code === 'ON_NAP' ? "black" :
          result.candidate_party_code === 'ON_NA' ? "black" :
          result.candidate_party_code === 'ON_PPSN' ? "ppsn" :
          result.candidate_party_code === 'ON_PSN' ? "ppsn" :
          result.candidate_party_code === 'ON_PEO' ? "peo" :
          result.candidate_party_code === 'ON_CNS' ? "cons" :          
          result.candidate_party_code === 'ON_COM' ? "com" :
          result.candidate_party_code === 'ON_MUL' ? "mult" :                            
          result.candidate_party_code === 'ON_CAP' ? "darkpurple" :
          result.candidate_party_code === 'AB_WAP' ? "darkpurple" :
          result.candidate_party_code === 'AB_WRP' ? "darkpurple" :  
          result.candidate_party_code === 'AB_FCP' ? "darkblue" :          
          result.candidate_party_code === 'AB_SC' ? "darkgreen" :                    
          result.candidate_party_code === 'AB_EPA' ? "success" :          
          result.candidate_party_code === 'AB_GPA' ? "success" :                    
          result.candidate_party_code === 'ON_MOD' ? "mod" :                    
          result.candidate_party_code === 'FED_BQ' ? "info" : 
          result.candidate_party_code === 'AB_SPA' ? "black" : 
          result.candidate_party_code === 'AB_AIP' ? "black" : 
          result.candidate_party_code === 'AB_AAP' ? "pink" : 
          result.candidate_party_code === 'FED_CA' ? "darkgreen" : 
          result.candidate_party_code === 'ON_GPO' ? "success" : 
          result.candidate_party_code === 'FED_PC' ? "lightblue" : 
          result.candidate_party_code === 'ON_FRE' ? "darkblue" : 
          result.candidate_party_code === 'ON_NBO' ? "nbo" : 
          result.candidate_party_code === 'ON_TRI' ? "darkpurple" : 
          result.candidate_party_code === 'ON_LTN' ? "yellow" :
          result.candidate_party_code === 'AB_AP' ? "yellow" :
          "secondary"}>{result.year}</CBadge>
        { i !== props.theData.findProvincialPollMaps.candidates.length - 1 ? <div className="dropdown-divider"></div> : <></> }
      </div></CLink>
      
      ))}             
      </div> : <></> }
      </div></div></div> : <></> : <></> : <></> : <></> : <></> }        
      </div>
    )
  }
  
  export default SearchResultsProvincialPollMaps;